const { getElements, getOffsetTop } = window.BAO.Utils

class CollectionScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    this.onProductGridChanged = this.onProductGridChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT_GRID.RENDERED,
      this.onProductGridChanged,
    )
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveGrid()
  }

  moveGrid () {
    if (!window.BAO.MediaBreakpoints.isSm) return

    const navWidthPercent = (190 / window.innerWidth) * 100
    const scrollerViewportWidth = 100 - navWidthPercent

    const heroOffset = this.dataset.hasHero === 'true' ? 380 : 0

    const maxScrollAmount =
      this.totalCardSize + this.totalPromoSize - scrollerViewportWidth

    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this) + heroOffset
    const elementEndPoint =
      getOffsetTop(this) + elementHeight - window.innerHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.style.setProperty('--Scroll_Amount', `0vw`)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.setProperty('--Scroll_Amount', `-${maxScrollAmount}vw`)

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const scrollAmount = maxScrollAmount * scrollYAsAPercentageOfJourney

    this.style.setProperty('--Scroll_Amount', `-${scrollAmount}vw`)
  }

  onProductGridChanged () {
    const productEls = getElements(this.els.product?.selector)
    const promoEls = getElements(this.els.promo?.selector)
    const paginationEls = getElements(this.els.pagination?.selector)

    const productWidthCalc = productEls.length * this.singleCardSize
    const promoWidthCalc = promoEls.length * this.singlePromoSize
    const paginationWidthCalc = paginationEls.length * this.singleCardSize

    const newTotalCards = productWidthCalc + paginationWidthCalc
    const newTotalPromos = promoWidthCalc

    const newTotalHeight =
      productWidthCalc + promoWidthCalc + paginationWidthCalc

    this.setAttribute('data-total-card-size', newTotalCards)
    this.setAttribute('data-total-promo-size', newTotalPromos)
    this.style.setProperty('--Card_Total', `${newTotalHeight}vh`)
  }

  get singleCardSize () {
    if (window.BAO.MediaBreakpoints.isSmViewport) {
      return parseInt(this.dataset.cardSizeTablet)
    } else if (
      window.BAO.MediaBreakpoints.isMdViewport ||
      window.BAO.MediaBreakpoints.isLgViewport
    ) {
      return parseInt(this.dataset.cardSizeDesktop)
    } else {
      return parseInt(this.dataset.cardSizeLargeDesktop)
    }
  }

  get totalCardSize () {
    if (window.BAO.MediaBreakpoints.isSmViewport) {
      return parseInt(this.dataset.totalCardSizeTablet)
    } else if (
      window.BAO.MediaBreakpoints.isMdViewport ||
      window.BAO.MediaBreakpoints.isLgViewport
    ) {
      return parseInt(this.dataset.totalCardSizeDesktop)
    } else {
      return parseInt(this.dataset.totalCardSizeLargeDesktop)
    }
  }

  get singlePromoSize () {
    return parseInt(this.dataset.promoSize)
  }

  get totalPromoSize () {
    return parseInt(this.dataset.totalPromoSize)
  }
}

if (!customElements.get('collection-scroll')) {
  customElements.define('collection-scroll', CollectionScroll)
}
